import {
  memo,
  useState,
  useContext,
  useEffect,
  Fragment,
  useCallback,
} from "react";
import { Box, Text, Flex, useMantineTheme, Loader } from "@mantine/core";
import {
  GetTransactionRecordQuery,
  useGetTransactionRecordLazyQuery,
} from "src/generated/graphql";
import { AppContext } from "src/api/AppContext";
import { TbArrowsRightLeft } from "react-icons/tb";
import { formatter, groupByDate } from "src/utils/constants";
import { formatDate } from "src/utils/dateHelper";
import DetailModal from "./DetailModal";
import { useModals } from "@mantine/modals";

export type ITransaction = GetTransactionRecordQuery["transactionByClient"];

function Transactions() {
  const modals = useModals();
  const theme = useMantineTheme();
  const { currentClient } = useContext(AppContext);
  const [transactionsDetails, setTransactionsDetails] = useState<
    ITransaction[]
  >([]);

  useEffect(() => {
    currentClient?.id &&
      getTransactions({ variables: { clientId: currentClient.id } });
  }, [currentClient]);

  const [getTransactions, { loading }] = useGetTransactionRecordLazyQuery({
    onCompleted: (data) => {
      setTransactionsDetails(
        groupByDate(data.transactionByClient, (item) => item.createdDate, "DSC")
      );
    },
  });

  const handleModal = useCallback((detail) => {
    modals.openModal({
      closeOnClickOutside: false,
      title: "Transaction Details",
      children: <DetailModal detail={detail} />,
    });
  }, []);

  if (loading)
    return <Loader width={"100%"} mt={"xl"} sx={{ margin: "auto" }} />;
  return (
    <>
      {!transactionsDetails.length && (
        <Text
          align="center"
          fw={"bolder"}
          size={"xl"}
          color={theme.colors.secondaryTextColor[6]}
        >
          No Transaction found
        </Text>
      )}
      {transactionsDetails?.map((trasaction) => (
        <Fragment key={trasaction[0].id}>
          <Text
            size={14}
            fw={600}
            color={theme.colors.secondaryTextColor[6]}
            mt={"md"}
          >
            {formatDate(trasaction[0].createdDate).formatNumeric}
          </Text>
          {trasaction?.map((e) => (
            <Flex
              key={e.id}
              mt={"xs"}
              justify={"space-between"}
              onClick={() => handleModal(e)}
            >
              <Flex gap={"md"} align={"center"}>
                <Flex
                  sx={{
                    background: theme.colors.primary[6],
                    padding: 5,
                    borderRadius: 5,
                    minWidth: 39,
                    maxHeight: 41,
                    minHeight: 41,
                  }}
                  align={"center"}
                  justify={"center"}
                >
                  <TbArrowsRightLeft
                    size={15}
                    color={theme.colors.primaryTextColor[6]}
                  />
                </Flex>
                <Box style={{ color: theme.colors.secondaryTextColor[6] }}>
                  <Text>{e.location.name}</Text>
                  <Text size={14} color={theme.colors.secondaryTextColor[4]}>
                    {e.transactionStatus}
                  </Text>
                </Box>
              </Flex>
              <Text style={{ color: theme.colors.secondaryTextColor[6] }}>
                {formatter.format(e.amount)}
              </Text>
            </Flex>
          ))}
        </Fragment>
      ))}
    </>
  );
}

export default memo(Transactions);
